export default __webpack_public_path__ + "img/legal-mobile.png?a967";